import CompanyKycService from '../../services/CompanyKycService';
import toast from 'react-hot-toast';

// Action Types
export const LOADING_TOGGLE_ACTION = '[CompanyKyc] Loading Toggle';
export const COMPANY_KYC_LIST_INITIATED = '[CompanyKyc] Company KYC List Initiated';
export const COMPANY_KYC_INITIATED = '[CompanyKyc] Company KYC Initiated';
export const COMPANY_KYC_LIST_LOADED = '[CompanyKyc] Company KYC List Loaded';
export const COMPANY_KYC_LOADED = '[CompanyKyc] Company KYC Loaded';
export const COMPANY_KYC_FAILED = '[CompanyKyc] Company KYC Failed';
export const COMPANY_KYC_CREATED = '[CompanyKyc] Company KYC Created';
export const COMPANY_KYC_UPDATED = '[CompanyKyc] Company KYC Updated';
export const COMPANY_KYC_DELETED = '[CompanyKyc] Company KYC Deleted';
export const KYC_MASTERS_LOADED = '[CompanyKyc] KYC Masters Loaded';
export const CLEAR_CURRENT_COMPANY_KYC = '[CompanyKyc] Clear Current Company KYC';
export const CLEAR_ERRORS = '[CompanyKyc] Clear Errors';
export const SET_CURRENT_PAGE = '[CompanyKyc] Set Current Page';
export const SET_FILTERS = '[CompanyKyc] Set Filters';
export const RESET_COMPANY_KYC_SUCCESS = '[CompanyKyc] Reset Success State';

// Action Creators
export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}

export const getCompanyKycAction = (params = {}) => {
    return (dispatch) => {
        dispatch({ type: COMPANY_KYC_LIST_INITIATED });
        dispatch(loadingToggleAction(true));
        
        CompanyKycService.getAllCompanyKyc(params)
            .then((response) => {
                if (response.success) {
                    dispatch({ 
                        type: COMPANY_KYC_LIST_LOADED, 
                        payload: {
                            data: response.data,
                            pagination: response.pagination
                        }
                    });
                }
                else{
                    dispatch({ 
                        type: COMPANY_KYC_LIST_LOADED, 
                        payload: {
                            data: [],
                            pagination: response.pagination
                        }
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: COMPANY_KYC_FAILED, payload: error.message || 'Failed to load company KYC requirements' });
            })
            .finally(() => {
                dispatch(loadingToggleAction(false));
            });
    };
};

export const getCompanyKycByIdAction = (id) => {
    return (dispatch) => {
        dispatch({ type: COMPANY_KYC_INITIATED });
        dispatch(loadingToggleAction(true));
        
        return CompanyKycService.getCompanyKycById(id)
            .then((response) => {
                if (response.success) {
                    dispatch({ type: COMPANY_KYC_LOADED, payload: response.data });
                    return response.data;
                } else {
                    dispatch({ type: COMPANY_KYC_FAILED, payload: response.message });
                    throw new Error(response.message);
                }
            })
            .catch((error) => {
                const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch company KYC requirement';
                dispatch({ type: COMPANY_KYC_FAILED, payload: errorMessage });
                throw error;
            })
            .finally(() => {
                dispatch(loadingToggleAction(false));
            });
    };
};

export const createCompanyKycAction = (companyKycData, navigate) => {
    return (dispatch) => {
        dispatch({ type: COMPANY_KYC_INITIATED });
        dispatch(loadingToggleAction(true));
        
        return CompanyKycService.createCompanyKyc(companyKycData)
            .then((response) => {
                if (response.success) {
                    dispatch({ type: COMPANY_KYC_CREATED, payload: response.data });
                    toast.success(response.message || "Company KYC requirement created successfully");
                    dispatch(resetCompanyKycSuccess());
                    if (navigate) {
                        navigate('/company-kyc');
                    }
                } else {
                    dispatch({ type: COMPANY_KYC_FAILED, payload: response.message });
                    toast.error(response.message || "Failed to create company KYC requirement");
                }
            })
            .catch((error) => {
                let errorMessage = 'An error occurred';
                
                if (error && error.response && error.response.data) {
                    errorMessage = error.response.data.message || 'Server error occurred';
                    dispatch({ type: COMPANY_KYC_FAILED, payload: error.response.data });
                } else {
                    errorMessage = error.message || 'Network error occurred';
                    dispatch({ type: COMPANY_KYC_FAILED, payload: errorMessage });
                }
                
                toast.error(errorMessage);
            })
            .finally(() => {
                dispatch(loadingToggleAction(false));
            });
    };
};

export const updateCompanyKycAction = (id, companyKycData, navigate) => {
    return (dispatch) => {
        dispatch({ type: COMPANY_KYC_INITIATED });
        dispatch(loadingToggleAction(true));
        
        return CompanyKycService.updateCompanyKyc(id, companyKycData)
            .then((response) => {
                if (response.success) {
                    dispatch({ type: COMPANY_KYC_UPDATED, payload: response.data });
                    toast.success(response.message || "Company KYC requirement updated successfully");
                    dispatch(resetCompanyKycSuccess());
                    if (navigate) {
                        navigate('/company-kyc');
                    }
                } else {
                    dispatch({ type: COMPANY_KYC_FAILED, payload: response.message });
                    toast.error(response.message || "Failed to update company KYC requirement");
                }
            })
            .catch((error) => {
                let errorMessage = 'An error occurred';
                
                if (error && error.response && error.response.data) {
                    errorMessage = error.response.data.message || 'Server error occurred';
                    dispatch({ type: COMPANY_KYC_FAILED, payload: error.response.data });
                } else {
                    errorMessage = error.message || 'Network error occurred';
                    dispatch({ type: COMPANY_KYC_FAILED, payload: errorMessage });
                }
                
                toast.error(errorMessage);
            })
            .finally(() => {
                dispatch(loadingToggleAction(false));
            });
    };
};

export const deleteCompanyKycAction = (id) => {
    return (dispatch) => {
        dispatch({ type: COMPANY_KYC_INITIATED });
        dispatch(loadingToggleAction(true));
        
        return CompanyKycService.deleteCompanyKyc(id)
            .then((response) => {
                if (response.success) {
                    dispatch({ type: COMPANY_KYC_DELETED, payload: id });
                    dispatch(getCompanyKycAction()); // Refresh list after delete
                    toast.success(response.message || "Company KYC requirement deleted successfully");
                    dispatch(resetCompanyKycSuccess());
                } else {
                    dispatch({ type: COMPANY_KYC_FAILED, payload: response.message });
                    toast.error(response.message || "Failed to delete company KYC requirement");
                }
            })
            .catch((error) => {
                const errorMessage = error.response?.data?.message || error.message || 'Failed to delete company KYC requirement';
                dispatch({ type: COMPANY_KYC_FAILED, payload: errorMessage });
                toast.error(errorMessage);
            })
            .finally(() => {
                dispatch(loadingToggleAction(false));
            });
    };
};

export const getKycMastersAction = (params = {}) => {
    return (dispatch) => {
        dispatch(loadingToggleAction(true));
        
        CompanyKycService.getKycMasterList(params)
            .then((response) => {
                if (response.success) {
                    dispatch({ type: KYC_MASTERS_LOADED, payload: response.data });
                } else {
                    dispatch({ type: COMPANY_KYC_FAILED, payload: response.message });
                }
            })
            .catch((error) => {
                dispatch({ type: COMPANY_KYC_FAILED, payload: error.message || 'Failed to load KYC masters' });
            })
            .finally(() => {
                dispatch(loadingToggleAction(false));
            });
    };
};

// Additional helper actions
export function clearCurrentCompanyKyc() {
    return {
        type: CLEAR_CURRENT_COMPANY_KYC
    };
}

export function clearErrors() {
    return {
        type: CLEAR_ERRORS
    };
}

export function setCurrentPage(page) {
    return {
        type: SET_CURRENT_PAGE,
        payload: page
    };
}

export function setFilters(filters) {
    return {
        type: SET_FILTERS,
        payload: filters
    };
}

// New action creators for better API alignment
export const getCompanyKycList = (params = {}) => {
    return getCompanyKycAction(params);
};

export const createCompanyKyc = (data, navigate) => {
    return createCompanyKycAction(data, navigate);
};

export const updateCompanyKyc = (id, data, navigate) => {
    return updateCompanyKycAction(id, data, navigate);
};

export const deleteCompanyKyc = (id) => {
    return deleteCompanyKycAction(id);
};

export const getCompanyKycById = (id) => {
    return getCompanyKycByIdAction(id);
};

export const getKycMasters = (params = {}) => {
    return getKycMastersAction(params);
};

export const resetCompanyKycSuccess = () => ({
    type: RESET_COMPANY_KYC_SUCCESS
});